export interface StreamingMessage {
  id: string;
  status: 'pending' | 'complete' | 'error' | 'abort';
  type?: 'reset' | 'alfred';
}

const isStreamingMessageComplete = (message: StreamingMessage): boolean =>
  message.status === 'complete' && message.type !== 'reset';

export const getNewlyCompletedStreamingResponses = (
  messages: StreamingMessage[],
  previousMessages: StreamingMessage[]
): string[] => {
  const previousMessagesById = new Map(
    previousMessages.map(message => [message.id, message])
  );

  return messages.reduce<string[]>((messageIds, message) => {
    const previousMessage = previousMessagesById.get(message.id);

    if (
      previousMessage &&
      !isStreamingMessageComplete(previousMessage) &&
      isStreamingMessageComplete(message)
    ) {
      messageIds.push(message.id);
    }

    return messageIds;
  }, []);
};
